import { TextField } from '@mui/material';
import * as React from 'react';
import { IInputDefaultProps } from './i-input-default-props';

interface IDTextField extends IInputDefaultProps {
    label: string;
    helperText?: string;
    onChange: (value: string) => void;
    value: string;
    disabled?: boolean;
    disableGutters?: boolean;
    // Hides the helper text on 'md' and below (shown only on 'lg'+) — opt-in,
    // used by general/search filters to save vertical space on smaller
    // screens. Other DTextField usages (form fields, etc.) are unaffected.
    hideHelperTextBelowLg?: boolean;
}

export function DTextField({
    label,
    helperText,
    onChange,
    value,
    disabled,
    disableGutters = true,
    error,
    hideHelperTextBelowLg = false,
}: IDTextField) {
    return (
        <TextField
            onChange={(e) => {
                onChange(e.target.value || '');
            }}
            value={value}
            disabled={disabled}
            sx={{
                my: !disableGutters ? 2 : 0,
                // Fill the container and allow shrinking — no hard min-width. A
                // fixed floor (the old 25rem ≈ 400px) overflowed on mobile and
                // inside narrow content areas / non-wrapping toolbars. width:100%
                // + the parent's flex-grow keep search filters comfortably wide
                // when there's room; they shrink safely when there isn't.
                width: '100%',
                minWidth: 0,
                ...(hideHelperTextBelowLg
                    ? {
                          '& .MuiFormHelperText-root': {
                              display: { xs: 'none', lg: 'block' },
                          },
                      }
                    : {}),
            }}
            label={label}
            helperText={helperText || ''}
            margin={'dense'}
            size={'small'}
        />
    );
}
